// @flow

import type {
  ActionHandlers,
  Reducer,
} from '@travel-frontend/state-handling-sdk';
import type {PostServiceFeedbackSuccess} from 'redux/v1/serviceFeedback/actions';
import type {ServiceFeedbackState} from 'redux/v1/serviceFeedback/ServiceFeedbackState';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';

import {POST_SERVICE_FEEDBACK} from 'redux/v1/serviceFeedback/actions';

export const initialState: ServiceFeedbackState = {
  loading: false,
};

const actionCreators: ActionHandlers<ServiceFeedbackState> = {
  [PENDING(POST_SERVICE_FEEDBACK)]: (state: ServiceFeedbackState) => ({
    ...initialState,
    loading: true,
  }),
  [SUCCESS(POST_SERVICE_FEEDBACK)]: (
    state: ServiceFeedbackState,
    action: PostServiceFeedbackSuccess
  ) => ({
    ...state,
    loading: false,
    status: true,
  }),
  [ERROR(POST_SERVICE_FEEDBACK)]: (
    state: ServiceFeedbackState,
    action: any
  ) => ({
    ...state,
    loading: false,
    status: false,
    error: action.error,
  }),
};

// $FlowIgnore
export const serviceFeedbackReducer: Reducer<ServiceFeedbackState> =
  // $FlowIgnore
  createReducerUsingActionHandlers<ServiceFeedbackState>(
    initialState,
    actionCreators
  );
